/**
 * GBA/ITC Gateway API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CredentialDeliveryDto { 
    /**
     * Type of credential to deliver
     */
    credentialType?: CredentialDeliveryDto.CredentialTypeEnum;
    /**
     * Specific credential IDs to deliver (optional)
     */
    credentialIds?: Array<string>;
}
export namespace CredentialDeliveryDto {
    export const CredentialTypeEnum = {
        VerifiableCredential: 'VerifiableCredential',
        GbaFacilityReportIssuer: 'GBAFacilityReportIssuer',
        GbaVerifiedCompany: 'GBAVerifiedCompany',
        GbaApprovedVerifierCredential: 'GBAApprovedVerifierCredential',
        GbaApprovedCertifierCredential: 'GBAApprovedCertifierCredential',
        GbaApprovedCarbonCalculationPartnerCredential: 'GBAApprovedCarbonCalculationPartnerCredential'
    } as const;
    export type CredentialTypeEnum = typeof CredentialTypeEnum[keyof typeof CredentialTypeEnum];
}


